import {
  ImpersonationDraft,
  useApplyImpersonation,
  useGrippContext,
  useImpersonationDraft,
} from '@gripp/shared-logic';
import { ImpersonationPicker, useSlideLayout } from '@gripp/shared-ui';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const ImpersonationUserColumn = () => {
  const { t } = useTranslation();
  const { logger } = useGrippContext();
  const { setColumnTitle } = useSlideLayout();
  const { apply } = useApplyImpersonation();
  const { clearDraft } = useImpersonationDraft();
  const appliedRef = useRef(false);

  useEffect(() => {
    setColumnTitle(t('impersonation.picker.userTitle'));
    return () => setColumnTitle(undefined);
  }, [setColumnTitle, t]);

  // Leaving the picker without completing it discards the draft: a
  // workspace-only selection must not linger as a half-applied state in the
  // settings menu.
  useEffect(() => {
    return () => {
      if (!appliedRef.current) {
        clearDraft();
      }
    };
  }, [clearDraft]);

  // Any selection (a user or "Continue without a user") applies the
  // impersonation immediately — there is no separate confirm step anymore.
  // Full page load on /settings so the app restarts under the new identity
  // (and doesn't reload back into this picker column).
  const onSelected = (draft: ImpersonationDraft) => {
    const run = async () => {
      await apply(draft);
      appliedRef.current = true;
      clearDraft();
      window.location.assign('/settings');
    };
    run().catch((error) =>
      logger?.error(error, 'Failed to apply impersonation')
    );
  };

  return <ImpersonationPicker mode="user" onSave={onSelected} />;
};
